import React from 'react';
import { applyStyles } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';
import i18n from 'i18n';
import BlockHeader from 'components/common/BlockHeader';
import Button from 'components/common/Button';
import {
  pcStyle as tablePCStyle,
  spStyle as tableSPStyle
} from 'components/OrderAggregators/styles/table';
import DeliveryDialog from 'components/OrderAggregators/components/DeliveryDialog';
import DeliveryPreferred from 'constants/delivery-preferred';
import { PreferredTimeOptions } from 'constants/preferred-delivery-time';
import moment from 'moment';
import PaymentType from 'constants/payment-type';
import SessionManager from 'util/session-manager';

class Delivery extends React.Component {
  constructor(props) {
    super(props);

    this.deliveryDialogRef = React.createRef();
  }

  handleDeliveryDialogSave(props, value) {
    const { change } = props;
    change('deliveries', value);

    let storedData;
    try {
      storedData = SessionManager.load();
    } catch (error) {
      switch (error.name) {
        case 'NoSessionError':
        case 'SessionExpiredError':
        case 'LoadDataError':
          this.props.push('/error');
          return;

        default:
          throw error;
      }
    }
    storedData.deliveries = value;
    SessionManager.save(storedData);
  }

  render() {
    const { className, form, datepickerMin, datepickerMax } = this.props;
    const deliveries = form.getState().values.deliveries;
    const payment = form.getState().values.payment;

    if (!deliveries) return;

    return (
      <div className={className}>
        <BlockHeader>
          {i18n.t('orderAggregators:confirmation:deliveryInfo')}
        </BlockHeader>
        {payment.type === PaymentType.card ? (
          <React.Fragment>
            <table className="confirm-table">
              <tbody>
                <tr>
                  <th>
                    {i18n.t(
                      'orderAggregators:confirmation:deliveryPreferredDate'
                    )}
                  </th>
                  <td>
                    {deliveries.deliveryPreferred === DeliveryPreferred.on
                      ? moment(deliveries.preferredDate).format(
                          i18n.t('common:dateFormat.dateName')
                        )
                      : i18n.t('orderAggregators:confirmation:preferredOff')}
                  </td>
                </tr>
                <tr>
                  <th>
                    {i18n.t(
                      'orderAggregators:confirmation:deliveryPreferredTime'
                    )}
                  </th>
                  <td>
                    {deliveries.deliveryPreferred === DeliveryPreferred.on
                      ? PreferredTimeOptions.find(
                          option => option.value === +deliveries.preferredTime
                        ).label
                      : i18n.t('orderAggregators:confirmation:preferredOff')}
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="btn-wrapper">
              <Button
                buttonType="F"
                type="button"
                onClick={() => this.deliveryDialogRef.current.open()}
              >
                {i18n.t('orderAggregators:confirmation:edit')}
              </Button>
            </div>
            <DeliveryDialog
              deliveries={deliveries}
              dialogRef={this.deliveryDialogRef}
              onSubmit={v => this.handleDeliveryDialogSave(this.props.form, v)}
              datepickerMin={datepickerMin}
              datepickerMax={datepickerMax}
            />
          </React.Fragment>
        ) : (
          <table className="confirm-table">
            <tbody>
              <tr>
                <th>{i18n.t('orderAggregators:confirmation:deliveryDate')}</th>
                <td>
                  {i18n.t('orderAggregators:confirmation:deliveryDateNote')}
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    );
  }
}

const pcStyle = CustomMedia.greaterThan('umedium')`
  .btn-wrapper {
    width: 100%;
    margin: 24px 0 0;
    text-align: center;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .btn-wrapper {
    width: 100%;
    text-align: center;
    padding-top: 16px;
  }
`;

export default applyStyles(Delivery)(
  pcStyle,
  spStyle,
  tablePCStyle,
  tableSPStyle
);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Confirmation/components/Delivery.js